// defaults
module.exports = {
  'x': 0,
  'y': 0,
  // 'roundness': 0,
  'line-width': 3,
  'line-length': 50,
  'text-margin': 10,
  'font-size': 14,
  'font-color': 'black',
  // 'font': 'normal',
  // 'font-family': 'calibri',
  // 'font-weight': 'normal',
  'line-color': 'black',
  'element-color': 'black',
  'fill': 'white',
  'yes-text': 'yes',
  'no-text': 'no',
  'arrow-end': 'block',
  'class': 'flowchart',
  'scale': 1,
  'symbols': {
    'start': {},
    'end': {},
    'condition': {},
    'inputoutput': {},
    'input': {}, //tds
    'output': {}, //tds    
    'operation': {},
    'subroutine': {},
    'parallel': {}
  } //,
  // 'flowstate' : {
  //   'past' : { 'fill': '#CCCCCC', 'font-size': 12},
  //   'current' : {'fill': 'yellow', 'font-color': 'red', 'font-weight': 'bold'},
  //   'future' : { 'fill': '#FFFF99'},
  //   'invalid': {'fill': '#444444'}
  // }
};


//////////////////
// WEBPACK FOOTER
// ./src/flowchart.defaults.js
// module id = 8
// module chunks = 0